"use client";

import { CentraProvider } from "@frend-digital/future-centra/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React, { useState } from "react";

interface Props {
  children: React.ReactNode;
}
const GiftCardProviders = ({ children }: Props) => {
  const [client] = useState(() => new QueryClient());
  return (
    <QueryClientProvider client={client}>
      <CentraProvider>{children}</CentraProvider>
    </QueryClientProvider>
  );
};

export default GiftCardProviders;
